import { render, staticRenderFns } from "./CandidateCourses.vue?vue&type=template&id=f203a4d8&scoped=true&"
import script from "./CandidateCourses.vue?vue&type=script&lang=ts&"
export * from "./CandidateCourses.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateCourses.vue?vue&type=style&index=0&id=f203a4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203a4d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VImg,VRow,VSelect})
